module.exports = __webpack_public_path__ + "static/media/27-10.bccf2623.mp3";